/**
 * HighlightedText component to display text with highlighted keywords.
 * @param {string} props.text - The text to display.
 * @param {Array} props.keywords - The keywords to highlight in the text.
 * @returns {JSX.Element} - The rendered HighlightedText component.
 */
export default function HighlightedText({ text, keywords }) {
  console.log("keywords", keywords);
  if (!keywords || keywords.length === 0) return text;

  // Escape special regex characters in keywords
  const escapedKeywords = keywords.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const regex = new RegExp(`(${escapedKeywords.join('|')})`, 'gi');

  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) =>
        keywords.some(
          keyword => part.toLowerCase() === keyword.toLowerCase()
        ) ? (
          <span key={index} style={{ color: 'red', fontWeight: 'bold' }}>
            {part}
          </span>
        ) : (
          <span key={index}>{part}</span>
        )
      )}
    </>
  );
}
